import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loginData: null,
        accountData: null,
        userData: null,
        screen: null,
        userName: null,
        istrue: false
    },
    mutations: {
        setIstrue (state, msg) {
            state.istrue = msg
        },
        setLoginData (state, msg) {
            state.loginData = msg
        },
        setAccountData (state, msg) {
            state.accountData = msg
        },
        setUserData (state, msg) {
            state.userData = msg
        },
        setScreen (state, msg) {
            state.screen = msg
        },
        setUserName (state, msg) {
            state.userName = msg
        }
    },
    actions: {
    },
    modules: {
    }
})
